/** @flow */
import styled from 'styled-components';
import { TextField } from 'redux-form-material-ui';
import Paper from 'material-ui/Paper';

const STextField = styled(TextField) `
  margin: 16px 0 !important;
  width: 60% !important;
  font-size: 22px !important;
  @media (max-width: 1500px) {
    margin: 0 !important;
  }
  @media (max-width: 1050px) {
    width: 340px !important;
  }
  @media (max-width: 650px) {
    font-size: 16px !important;
    width: 80% !important;
  }
`;

const ButtonSubmit = styled.button`
  padding: 16px 0;
  margin: 0 16px;
  border-radius: 50px;
  color: white;
  min-width: 230px;
  cursor: pointer;
  user-select: none;
  background-color: ${({ theme }) => theme.colors.primary};
  transition: all 0.3s ease 0s;
  border-width: 0;
  font-size: 20px;
  outline: 0;
  text-align: center;
  &:hover {
    background-color: ${({ theme }) => theme.colors.secondaryAccent};
  }
  @media (max-width: 650px) {
    font-size: 16px;
    min-width: 190px;
    padding: 8px 0;
    margin-bottom: 16px;
    font-size: 16px;
    min-width: 190px;
  }
`;

const AuthWrapper = styled.div`
  width: 100%;
  height: 100vh;
  min-height: 750px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url(${({ theme }) => theme.images.background});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media (max-width: 600px) {
    height: 100%;
    min-height: 100vh;
    justify-content: flex-start;
    padding: 0;
  }
`;

const ButtonSection = styled.div`
  @media (max-width: 650px) {
    margin: 16px 0;
  }
`;

const Form = styled.form`
  width: 100%;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1050px) {
    height: 400px;
    justify-content: center;
    padding-top: 0;
  }
`;

const InputWrapper = styled.div`
  width: 100%;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
  @media (max-width: 650px) {
    height: auto;
    margin-bottom: 16px;
    justify-content: flex-start;
  }
`;

const LoginCard = styled(Paper) `
  width: 60%;
  height: 70%;
  padding: 32px;
  display: flex;
  flex-direction: row;
  @media (max-width: 1500px) {
    width: 80%;
  }
  @media (max-width: 1050px) {
    height: 85%;
    flex-direction: column;
  }
  @media (max-width: 650px) {
    min-height: 100vh;
  }
  @media (max-width: 600px) {
    height: 100%;
    width: 100%;
  }
`;

const LoginSection = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: none;
  margin: auto;
  @media (max-width: 1500px) {
    width: 100%;
    height: 100%;
  }
  @media (max-width: 650px) {
    height: 100%;
    flex: none;
    min-height: 100vh;
  }
`;

const Logo = styled.img`
  width: 350px;
`;

export {
  STextField,
  ButtonSubmit,
  LoginCard,
  Logo,
  Form,
  ButtonSection,
  InputWrapper,
  LoginSection,
  AuthWrapper,
};



// WEBPACK FOOTER //
// ./src/common/modules/authentication/styles.js